<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: Notifications -->
    <div
      v-on:click="reloadPage"
      class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
    >
      <span class="svg-icon svg-icon-xl svg-icon-primary">
        <inline-svg :src="$assetURL('media/svg/icons/General/Update.svg')" />
      </span>
      <span class="pulse-ring"></span>
    </div>
    <!--begin: Notifications -->
    <div
      @click="openNotification"
      v-if="is_staff"
      class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
    >
      <span class="svg-icon svg-icon-xl svg-icon-primary">
        <inline-svg
          :src="$assetURL('media/svg/icons/General/Notifications1.svg')"
        />
      </span>
      <span class="pulse-ring"></span>
      <span class="count-badge">{{ notification_count }}</span>
    </div>
    <!--End: Notifications -->
    <!--begin: Notifications -->
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
      v-if="false"
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg
              :src="$assetURL('media/svg/icons/Code/Compiling.svg')"
            />
          </span>
          <span class="pulse-ring"></span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-450px">
        <form>
          <KTDropdownNotification></KTDropdownNotification>
        </form>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Notifications -->

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
  .count-badge {
    position: absolute;
    top: -2px;
    right: -4px;
    background: #ee4d4d;
    height: 22px;
    min-width: 22px;
    color: white;
    border-radius: 8px;
    padding: 2px;
    font-size: 12px;
  }
}
</style>

<script>
import { SET_NOTIFICATION_DRAWER } from "@/core/services/store/common.module";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import { mapGetters } from "vuex";
import { currentUser } from "@/core/services/jwt.service";

export default {
  name: "KTTopbar",
  data() {
    return {
      notifyCount: 0,
    };
  },
  components: {
    KTQuickUser,
    KTDropdownNotification,
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    openNotification() {
      this.$store.commit(SET_NOTIFICATION_DRAWER, true);
    },
  },
  computed: {
    ...mapGetters(["notification_count"]),
    is_staff() {
      const user = currentUser();
      const role_name = this.lodash.toLower(user.role_name);
      return role_name == "admin";
    },
  },
};
</script>
<style>
.count-badge-new {
  position: absolute;
  top: 0px;
  right: -8px;
  background: #0093ff;
  height: 20px;
  min-width: 20px;
  color: #fff;
  border-radius: 8px;
  padding: 2px;
  font-size: 12px;
}
</style>
